"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NHSCourseDetailCarePackage_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var NHSCourseDetail_1 = require("./NHSCourseDetail");
var NHSCourseDetailCarePackage_Factory = /** @class */ (function () {
    function NHSCourseDetailCarePackage_Factory() {
    }
    NHSCourseDetailCarePackage_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CarePackageId: model.CarePackageId,
            ChargeExempt: model.ChargeExempt,
            NHSCourseDetail: NHSCourseDetail_1.NHSCourseDetail_Factory.CreateIncoming(model.NHSCourseDetail),
            OrigTxUrgent: model.OrigTxUrgent,
            PatientCharge: model.PatientCharge,
            Qty: model.Qty,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TreatmentPlanId: model.TreatmentPlanId,
        };
        return result;
    };
    NHSCourseDetailCarePackage_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CarePackageId: model.CarePackageId,
            ChargeExempt: model.ChargeExempt,
            NHSCourseDetail: NHSCourseDetail_1.NHSCourseDetail_Factory.CreateOutgoing(model.NHSCourseDetail),
            OrigTxUrgent: model.OrigTxUrgent,
            PatientCharge: model.PatientCharge,
            Qty: model.Qty,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TreatmentPlanId: model.TreatmentPlanId,
        };
        return result;
    };
    return NHSCourseDetailCarePackage_Factory;
}());
exports.NHSCourseDetailCarePackage_Factory = NHSCourseDetailCarePackage_Factory;
